/*
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2024-03-04 15:37:58
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-03-04 16:53:05
 * @FilePath: /chaoyongtuan/src/views/settings/tagManage/components/columns.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import ColumnTypes from '@/utils/ColumnTypes';

function getColumns(that) {
    let arr = [
        {
            key:'tagName',
            label: '标签',
            minWidth: '150',
            type: () => import('./tableCells/tagCell.vue'),
        },
        {
            label: '关联素材',
            type: () => import('./tableCells/countLinkCell.vue'),
            minWidth: '150',
        },
        {
            key:'addTime',
            label: '创建时间',
            type: ColumnTypes.TextCell
        },
        {
            key:'operations',
            label: '操作',
            minWidth: '180',
            type: ColumnTypes.ButtonsCell,
            align: 'right',
        },
    ]
    return arr;
}

export default getColumns;